import styled from 'styled-components';

const Wrapper = styled.aside`
  display: none;

  @media (min-width: 992px) {
    display: block;

    .sidebar-container {
      background: linear-gradient(180deg, #0f172a 0%, #1e1b4b 100%);
      min-height: 100vh;
      height: 100%;
      width: 260px;
      margin-left: -260px;
      transition: margin 0.3s ease-in-out;
      border-right: 1px solid rgba(255, 255, 255, 0.06);
    }

    .content {
      position: sticky;
      top: 0;
    }

    .show-sidebar {
      margin-left: 0;
    }

    header {
      height: 70px;
      display: flex;
      align-items: center;
      padding: 0 1.5rem;
      border-bottom: 1px solid rgba(255, 255, 255, 0.07);
      gap: 0.6rem;
    }

    .logo {
      width: 32px;
      height: 32px;
      background: linear-gradient(135deg, #6366f1, #8b5cf6);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      object-fit: contain;
      padding: 6px;
    }

    .brand-name {
      font-size: 1rem;
      font-weight: 700;
      color: #f1f5f9;
      letter-spacing: -0.02em;
    }

    .nav-links {
      padding: 1.25rem 0.75rem;
      display: flex;
      flex-direction: column;
      gap: 0.15rem;
    }

    .nav-link {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      color: #64748b;
      padding: 0.65rem 0.875rem;
      border-radius: 10px;
      text-transform: capitalize;
      font-size: 0.875rem;
      font-weight: 500;
      text-decoration: none;
      transition: background 0.15s, color 0.15s;

      &:hover {
        background: rgba(255, 255, 255, 0.07);
        color: #e2e8f0;
        .icon { color: #818cf8; }
      }
    }

    .active {
      background: rgba(99, 102, 241, 0.15);
      color: #e0e7ff;
      font-weight: 600;
      .icon { color: #818cf8; }
    }

    .icon {
      font-size: 1.1rem;
      display: flex;
      align-items: center;
      color: #475569;
      transition: color 0.15s;
      flex-shrink: 0;
    }
  }
`;

export default Wrapper;
